import { render, staticRenderFns } from "./EditorDropdown.vue?vue&type=template&id=9b27e756&scoped=true"
import script from "./EditorDropdown.vue?vue&type=script&lang=ts"
export * from "./EditorDropdown.vue?vue&type=script&lang=ts"
import style0 from "./EditorDropdown.vue?vue&type=style&index=0&id=9b27e756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b27e756",
  null
  
)

export default component.exports